<template>
  <div id="navbar-wrapper">
    <v-app-bar
      id="nav-app-bar"
      text
      theme="dark"
    >
      <HambugerMenuButton
        :set-drawer="setDrawer"
        :showing-drawer="showingDrawer"
        :is-logged-in="isLoggedIn"
      />
      <NavbarLogo />
      <v-spacer />
      <div>
        <HelpDialog
          :is-logged-in="isLoggedIn"
          :is-admin="showApiKey"
          :token-string="tokenString"
          :about-text="aboutText"
        />
        <ProfileListDialog
          :profile-list-is-open="profileListIsOpen"
          :is-logged-in="isLoggedIn"
          :sign-out="signOut"
          :displayname="displayname"
          :profile-details="profileDetails"
        />
        <LoginButton
          v-if="isLoggedIn"
          :is-logged-in="isLoggedIn"
        />
      </div>
    </v-app-bar>

    <NavDrawer
      :links="navbarLinksList"
      :showing-drawer="showingDrawer"
      :is-logged-in="isLoggedIn"
      :selected-customer="selectedCustomer"
      :set-drawer="setDrawer"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import navbarLinks from "@/router/navbarLinks";
import NavbarLogo from "./NavbarLogo.vue";
import NavDrawer from "../drawer/NavDrawer.vue";
import HelpDialog from "../modals/help-dialog/HelpDialog.vue";
import ProfileListDialog from "../modals/profile-dialog/ProfileListDialog.vue";
import HambugerMenuButton from "../buttons/HamburgerMenuButton.vue";
import LoginButton from "../buttons/LoginButton.vue";

export default defineComponent({
  name: "Navbar",
  components: {
    NavbarLogo,
    NavDrawer,
    HelpDialog,
    ProfileListDialog,
    LoginButton,
    HambugerMenuButton,
  },
  inject: ["$device"],
  props: {
    displayname: String,
    app: Object,
    isLoggedIn: Boolean,
    selectedCustomer: Object,
    auth: Object,
  },
  data() {
    return {
      showingDrawer: false,
      helpIsOpen: false,
      profileIsOpen: false,
      profileListIsOpen: false,
      signoutDialogIsOpen: false,
      showApiKey: false,
    };
  },
  computed: {
    tokenString() {
      return this.app?.userProfile?.token ?? "";
    },
    aboutText() {
      return `
        This web site for use by Qumulex authorized partners only.<br/>
        Updated: ${document.lastModified}<br/>
        &copy; Copyright ${new Date().getFullYear()}, Qumulex, Inc.
      `;
    },
    profileDetails() {
      if (this.app) {
        const { userProfile } = this.app;
        return userProfile && this.isLoggedIn
          ? `
            ${userProfile?.firstName} ${userProfile?.lastName}<br/>
            ${userProfile?.email}<br/>
            Role: ${userProfile?.role?.name}<br/>
            Company: ${userProfile?.companyName}<br/>
            Company Id: ${userProfile?.companyId}<br/>
          `
          : "no logged in user";
      } else return "none";
    },
    isMobile() {
      return this.$device.isMobile;
    },
    navbarLinksList() {
      if (this.isLoggedIn) {
        return navbarLinks(
          this.app.userProfile?.role?.privileges,
          this.selectedCustomer.id,
        );
      }
      return [];
    },
  },
  watch: {
    isMobile(newVal, oldVal) {
      if (newVal !== oldVal) this.showingDrawer = !newVal;
    },
    isLoggedIn(val) {
      // console.log("Navbar::watch isLoggedInd() changed, val:", val);
      // eslint-disable-next-line
      // this.isLoggedIn = val
      this.setDrawer(val);
    },
  },
  mounted() {
    this.showingDrawer = !this.isMobile;
  },
  beforeUpdate() {
    // before state updates, check if user is admin
    if (
      this.app?.userProfile?.role?.privileges &&
      this.app?.userProfile?.role?.privileges.includes("sysprep")
    ) {
      this.showApiKey = true;
    } else {
      this.showApiKey = false;
    }
  },
  methods: {
    setDrawer(val) {
      if (this.isLoggedIn) {
        this.showingDrawer = val;
      } else {
        this.showingDrawer = false;
      }
    },
    async signOut() {
      const user = {
        token: this.app.userProfile.token,
      };
      await this.auth.SignOut(user, this.app.restApi, this.app.reset);
    },
  },
});
</script>

<style scoped>
#nav-app-bar {
  background-color: rgba(12, 18, 20, 1);
}
</style>
